import { z } from 'zod';
import { SpellSchoolSchema, SourceSchema } from './common.schema';

const SpellComponentSchema = z.object({
  verbal: z.boolean(),
  somatic: z.boolean(),
  material: z.boolean(),
  materialDescription: z.string().optional(),
  materialCost: z.number().optional(),
  materialConsumed: z.boolean().optional(),
});

export const SpellSchema = z.object({
  id: z.string(),
  name: z.string(),
  level: z.number().min(0).max(9),
  school: SpellSchoolSchema,
  ritual: z.boolean(),
  castingTime: z.string(),
  range: z.string(),
  components: SpellComponentSchema,
  duration: z.string(),
  concentration: z.boolean(),
  description: z.string(),
  higherLevel: z.string().optional(),
  classes: z.array(z.string()),
  source: SourceSchema,
});

export type SpellData = z.infer<typeof SpellSchema>;
